import * as React from "react";
import { useState } from "react";
import { Box, Button, Typography, Grid2, TextField, FormHelperText, useMediaQuery, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import StepperCard from "../StepperCard";
import { CustomStepConnector, StepIcon, useSteps  } from "../StepperComponents"; // Import steps
import { useSelector, useDispatch } from 'react-redux';
import { checkAndNavigate, setActiveStep, setOccupation, setPersonalDetails, setQualification } from "../../../Redux/usersSlice";
import PersonalStyles from "./PersonalDetails.module.css";
import male from "../../../Assets/Images/maleIcon.svg";
import female from "../../../Assets/Images/femaleicon.svg";
import Logo from '../../../Assets/Images/logo.svg';
import OccupationStyles from "./Occupation.module.css";
import { submitQualificationQuestionnaire, submitOccupationQuestionnaire, submitPersonalQuestionnaire } from "../../../Redux/usersSlice";
import icon from "../../../Assets/Images/icon.svg"
import { ArrowBack } from "@mui/icons-material";
import collab from '../../../Assets/Images/collab1.svg';

export default function YourDetails() {
    const steps = useSteps();
    console.log('STEPS',steps)
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  const { activeStep, userData ,questionnaire,personalData,panDetails, guardian,source } = useSelector(state => state.user);

  const backendResponse = userData.steps

  const isMobile = useMediaQuery('(max-width:1000px)');
  const isSmallScreen = useMediaQuery('(max-width:600px)')


  // const [selectedGender, setSelectedGender] = useState("");
  // const [selectedMarital, setSelectedMarital] = useState(""); 
  // const [fatherName, setFatherName] = useState("");

  const [formData, setFormData] = useState({
    gender: questionnaire.personal?.gender || "",
    marital_status: questionnaire.personal?.marital_status || "",
    guardian: questionnaire.personal?.guardian || guardian || ""
  });

  const [formData1,setFormData1]=useState({
    occupation:questionnaire.occupationForm?.occupation || "",
    annual_income:questionnaire.occupationForm?.annual_income || ""
  })

  const [formData2,setFormData2]=useState({
    qualification:questionnaire.occupationForm?.qualification || "",
    investment_exp:questionnaire.occupationForm?.investment_exp || ""
  })

  // const [selectedOccupation, setSelectedOccupation] = useState(null);
  // const [selectedIncome, setSelectedIncome] = useState(null);

  // const [selectedInvestExp,setSelectedInvestExp]=useState(null)
  // const [selectedQualfication,setSelectedQualfication]=useState(null)
  
  const [occupationAnnual,setOccupationAnnual]=useState(false)
  const [investExpQuali,setInvestExpQuali]=useState(false)


  const [errorMsg, setErrorMsg] = useState("");
  const [errType, setErrType] = useState(0);



  
  React.useEffect(() => {
    if (panDetails || questionnaire.personal || personalData || guardian ) {
      setFormData({
        gender: questionnaire.personal?.gender ||  panDetails?.gender || personalData?.gender || "",
        marital_status: questionnaire.personal?.marital_status || personalData?.marital_status || "",
        guardian: questionnaire.personal?.guardian || panDetails?.guardian || personalData?.guardian || guardian || ""
      });
    }
    if (questionnaire.occupationForm || personalData) {
      setFormData1({
        occupation: questionnaire.occupationForm?.occupation ||personalData?.occupation ||  "",
        annual_income: questionnaire.occupationForm?.annual_income || personalData?.annual_income || "",
      });
    }
    if (questionnaire.qualificationForm || personalData) {
      setFormData2({
        qualification: questionnaire.qualificationForm?.qualification || personalData?.qualification || "",
        investment_exp: questionnaire.qualificationForm?.investment_exp ||personalData?.investment_exp ||  "",
      });
    }
  }, [questionnaire.personal,questionnaire.occupationForm,questionnaire.qualificationForm]);


  const handleGenderChange = (gender) => {
    setFormData(prev => ({ ...prev, gender }));
  };

  const handleMaritalChange = (marital_status) => {
    setFormData(prev => ({ ...prev, marital_status }));
  };

  const handleGuardianChange = (e) => {
    setFormData(prev => ({ ...prev, guardian: e.target.value }));
  };

  const handleOccupationChange = (occupation) => {
    setFormData1(prev => ({ ...prev, occupation }));
  };

  const handleAnnualChange = (annual_income) => {
    setFormData1(prev => ({ ...prev, annual_income }));
  };

  
  const handleQualificationChange = (qualification) => {
    setFormData2(prev => ({ ...prev, qualification }));
  };

  const handleInvestExpChange = (investment_exp) => {
    setFormData2(prev => ({ ...prev, investment_exp }));
  };
  


  // Sync step with URL path
  React.useEffect(() => {
    const currentStep = steps.findIndex(
      (step) => step.path === location.pathname
    );
    if (currentStep !== -1) dispatch(setActiveStep(currentStep));
  }, [location.pathname, setActiveStep]);

    React.useEffect(() => {
        if ( userData?.steps?.["Personal Detail"]?.status && !userData?.steps?.["Occupation"]?.status && !userData?.steps?.["Qualification"]?.status) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "occupation_page_viewed",
            page_path: window.location.pathname
          });
          setOccupationAnnual(true);
          }
          if(userData?.steps?.["Personal Detail"]?.status && userData?.steps?.["Occupation"]?.status && !userData?.steps?.["Qualification"]?.status){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "kyc_step_viewed",
              step_name: "qualification_page_viewed",
              page_path: window.location.pathname
            });
            setInvestExpQuali(true);
          }
          if(userData?.steps?.["Personal Detail"]?.status && userData?.steps?.["Occupation"]?.status && userData?.steps?.["Qualification"]?.status){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "kyc_step_viewed",
              step_name: "personaldetails_page_viewed",
              page_path: window.location.pathname
            });
            setOccupationAnnual(false)
            setInvestExpQuali(false)
          }
    },[])



  const handleStepNavigate = (path) => {
    const stepIndex = steps.findIndex((step) => step.path === path);
    if (stepIndex !== -1) {
      dispatch(setActiveStep(stepIndex));
      navigate(path);
    }
  };


  //   // Handle occupation button click
  //   const handleOccupationClick = (occupation) => {
  //     if (formData1.occupation === occupation) {
  //         setSelectedOccupation(null); // Deselect if already selected
  //     } else {
  //         setSelectedOccupation(occupation); // Select new occupation
  //     }
  // };

  // const handleQualficationClick=(qualification)=>{
  //   if (selectedQualfication === qualification) {
  //     setSelectedQualfication(null); // Deselect if already selected
  // } else {
  //   setSelectedQualfication(qualification); // Select new occupation
  // }
  // }

  //    // Handle annual income button click
  //    const handleIncomeClick = (income) => {
  //     if (selectedIncome === income) {
  //         setSelectedIncome(null); // Deselect if already selected
  //     } else {
  //         setSelectedIncome(income); // Select new income
  //     }
  // };

       // Handle annual income button click
    //    const handleInvestExp = (invexp) => {
    //     if (selectedInvestExp === invexp) {
    //       setSelectedInvestExp(null); // Deselect if already selected
    //     } else {
    //       setSelectedInvestExp(invexp); // Select new income
    //     }
    // };




  const handleGotoOccupation = async () => {
    setErrorMsg("");
    setErrType(0);



    // const isFatherNameValid = validateFatherName();
    // if (!isFatherNameValid) return;

    const isGenderValid = validateGender();
    if (!isGenderValid) return;

    const isMaritalStatusValid = validateMaritalStatus();
    if (!isMaritalStatusValid) return;

    if(formData.guardian.trim().length===0){
      setErrType(21);
      setErrorMsg("Father's/Spouse's name is required.");
      return;
    }

   
    console.log("All fields are valid. Proceeding...");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "personaldetails_entered",
      page_path: window.location.pathname
    });

    try {

      const response=await dispatch(submitPersonalQuestionnaire({
        email: userData.email.toLowerCase(),
        mobile: userData.mobile,
        marital_status: formData.marital_status,
        guardian: formData.guardian,
        gender: formData.gender
      })).unwrap();

      console.log(response)
      if(response.data?.success){

        console.log("oneee")
        dispatch(setPersonalDetails({
          email: userData.email.toLowerCase(),
        mobile: userData.mobile,
        marital_status: formData.marital_status,
        guardian: formData.guardian,
        gender: formData.gender
        }))

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "occupation_page_viewed",
          page_path: window.location.pathname
        });
        setOccupationAnnual(true)

      }
      // Handle success (e.g., show success message or navigate to next step)
    } catch (error) {
      // Handle error (e.g., show error message)
      console.error("Failed to submit personal questionnaire:", error);
    }



  };

  const handleGotoInvest=async()=>{
  // Validate occupation
  if (!formData1.occupation || formData1.occupation.trim().length === 0) {
    setErrType(22); // Use a different error type number
    setErrorMsg("Occupation is required.");
    return;
  }

  // Validate annual income
  if (!formData1.annual_income || formData1.annual_income.trim().length === 0) {
    setErrType(23);
    setErrorMsg("Annual income is required.");
    return;
  }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "occupation_entered",
      page_path: window.location.pathname
    });
    try {
      // const { email, mobile, occupation, annual_income } = formData;
      const response = await dispatch(submitOccupationQuestionnaire({
        email: userData.email.toLowerCase(),
        mobile:userData.mobile,
        occupation:formData1.occupation,
        annual_income:formData1.annual_income
      })).unwrap();
      
      // Handle success
      if(response.data.success){
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "qualification_page_viewed",
          page_path: window.location.pathname
        });
        setInvestExpQuali(true)
        dispatch(setOccupation({
          email: userData.email.toLowerCase(),
          mobile:userData.mobile,
          occupation:formData1.occupation,
          annual_income:formData1.annual_income
        }))
      }
    } catch (error) {
      // Handle error
      console.error("Failed to submit occupation questionnaire:", error);
    }
  }

  
  const handleNextStep = async() => {

  // Validate qualification
  if (!formData2.qualification || formData2.qualification.trim().length === 0) {
    setErrType(24);
    setErrorMsg("Qualification is required.");
    return;
  }

  // Validate investment experience
  if (!formData2.investment_exp || formData2.investment_exp.trim().length === 0) {
    setErrType(25);
    setErrorMsg("Investment experience is required.");
    return;
  }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "qualification_entered",
      page_path: window.location.pathname
    });

    try {
      // const { email, mobile, investment_exp, qualification } = formData;
      const response=await dispatch(submitQualificationQuestionnaire({
        email: userData.email.toLowerCase(),
        mobile:userData.mobile,
        qualification:formData2.qualification,
        investment_exp:formData2.investment_exp

      })).unwrap();

      console.log(response)

      if(response.data.success){
        dispatch(setQualification({
          email: userData.email.toLowerCase(),
          mobile:userData.mobile,
          qualification:formData2.qualification,
          investment_exp:formData2.investment_exp
        }))
         const { payload } = await dispatch(checkAndNavigate());
        
            console.log(payload.allComplete)
        
            if (payload.allComplete) {
              // All required steps completed - go to products
              console.log("Navigating to dis page...")
              navigate("/dis");
            }else{
        
               // First check if there are incomplete steps forward (normal flow)
               let nextIncompleteStep = null;
                   
               // Check forward steps first
               for (let i = activeStep + 1; i < steps.length; i++) {
                 const step = steps[i];
                 const isComplete = step.substeps
                   ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                   : userData.steps[step.name]?.status;
                 console.log("Forward steps completed --->", isComplete)
           
                 if (!isComplete) {
                   nextIncompleteStep = step;
                   console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
                   break;
                 }
               }
           
               // If no incomplete steps forward, check all steps
               if (!nextIncompleteStep) {
                 console.log("No incomplete steps forward checking any in backward steps")
                 for (let i = 0; i < steps.length; i++) {
                   const step = steps[i];
                   const isComplete = step.substeps
                     ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                     : userData.steps[step.name]?.status;
           
                   if (!isComplete) {
                     nextIncompleteStep = step;
                     console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
                     break;
                   }
                 }
               }
           
               const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
               console.log("Navigating to the specific step according to the condition", stepIndex)
               if (stepIndex !== -1) {
                 dispatch(setActiveStep(stepIndex));
                 navigate(nextIncompleteStep.path);
               }
        
            }
      }
    
    
    } catch (error) {
      // Handle error
      console.error("Failed to submit qualification questionnaire:", error);
    }
   
  };



  const validateGender = () => {
    if (!formData.gender) {
      setErrType(4);
      setErrorMsg("Gender selection is required.");
      return false;
    }
    return true;
  };

  const validateMaritalStatus = () => {
    if (!formData.marital_status) {
      setErrType(5);
      setErrorMsg("Marital Status selection is required.");
      return false;
    }
    return true;
  };

  const handleSkipPD=()=>{
     // First check if there are incomplete steps forward (normal flow)
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "personaldetails_skipped",
            page_path: window.location.pathname
          });
               let nextIncompleteStep = null;
                   
               // Check forward steps first
               for (let i = activeStep + 1; i < steps.length; i++) {
                 const step = steps[i];
                 const isComplete = step.substeps
                   ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                   : userData.steps[step.name]?.status;
                 console.log("Forward steps completed --->", isComplete)
           
                 if (!isComplete) {
                   nextIncompleteStep = step;
                   console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
                   break;
                 }
               }
           
               // If no incomplete steps forward, check all steps
               if (!nextIncompleteStep) {
                 console.log("No incomplete steps forward checking any in backward steps")
                 for (let i = 0; i < steps.length; i++) {
                   const step = steps[i];
                   const isComplete = step.substeps
                     ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                     : userData.steps[step.name]?.status;
           
                   if (!isComplete) {
                     nextIncompleteStep = step;
                     console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
                     break;
                   }
                 }
               }
           
               const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
               console.log("Navigating to the specific step according to the condition", stepIndex)
               if (stepIndex !== -1) {
                 dispatch(setActiveStep(stepIndex));
                 if(stepIndex === activeStep){
                      window.alert("You’ve reached the last step of onboarding, and it must be completed to continue ...!")
                 }else{
                 navigate(nextIncompleteStep.path);
                 }
               }
  }

  return (
    <main>
    <Box sx={{
      display: "flex",
      flexDirection:isMobile ? "column" : "row",
      minHeight: "100vh !important",
      backgroundImage: `url(${SignUpBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}>

      <Typography
        sx={{
          textAlign: "center",
          fontSize: "16px",
          fontFamily: "Inter400",
          display: {
            xs: "block", // shown on small screens
          },
          mt: "5px",
          "@media (min-width:1000px)": {
            display: "none"
          }
        }}
      >
        {`You are on step ${activeStep + 1} out of 8`}
      </Typography>
      
      <StepperCard
        activeStep={activeStep}
        handleStepNavigate={handleStepNavigate}
        backendResponse={backendResponse}
        CustomStepConnector={CustomStepConnector}
        StepIcon={StepIcon}
        steps={steps}
      />



      {investExpQuali ?
        <Box className={OccupationStyles.main_card}>
          <Box className={OccupationStyles.content_wrapper}>
            {/* <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              width: '100%',
              marginBottom: '10px',
              marginTop: '10px',
            }}>
            
              <Box sx={{
                position: 'absolute',
                left: 0,

                '@media (min-width: 1000px)': {
                  display: 'none' // Explicitly hide above 1000px
                }
              }}>
                <IconButton
                  onClick={() => navigate('/step-4')} // Or your custom back handler
                  sx={{
                    color: '#000', // Customize color
                    padding: '16px'
                  }}
                >
                  <ArrowBack /> 
                </IconButton>
              </Box>

  
              <img
                src={Logo}
                alt="Logo"
                style={{
                  // Adjust margin to account for arrow on mobile
                  marginLeft: { xs: '40px', md: 0 }
                }}
                className={OccupationStyles.nav_logo}
              />
            </Box> */}
            <Box sx={{display:"flex",flexDirection:"column",alignItems:"center"}}>
              <img
                src={source == "cosmos" ? collab : Logo}
                alt="Logo"
                className={source == "cosmos" ? OccupationStyles.twologo :
                  OccupationStyles.nav_logo}
                alt="Logo"
                style={{
                  // Adjust margin to account for arrow on mobile
                  marginLeft: { xs: '40px', md: 0 }
                }}
              />
              {
                source == "cosmos" &&
                <Typography className={OccupationStyles.txt1}>
                  Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                </Typography>
              }
              
            </Box>
           

            <Typography className={OccupationStyles.title}>Qualification</Typography>



            {
              isSmallScreen ?
                <>

                  <Grid2 sx={{ display: "flex", flexDirection: "row", gap: "7px" }}>
                    <Grid2 className={OccupationStyles.occupation_card}>
                      <Button
                        className={`${OccupationStyles.buttoncard1} ${formData2.qualification === "Under High School" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleQualificationChange("Under High School")}
                      >
                        <span className={OccupationStyles.buttontext}>Under High School</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.buttoncard1} ${formData2.qualification === "Professional" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleQualificationChange("Professional")}
                      >
                        <span className={OccupationStyles.buttontext}>Professional</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.buttoncard1} ${formData2.qualification === "Under Graduate" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleQualificationChange("Under Graduate")}
                      >
                        <span className={OccupationStyles.buttontext}>Under Graduate</span>
                      </Button>

                      <Button
                        className={`${OccupationStyles.buttoncard1} ${formData2.qualification === "Post Graduate" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleQualificationChange("Post Graduate")}
                      >
                        <span className={OccupationStyles.buttontext}>Post Graduate</span>
                      </Button>
                    </Grid2>

                    <Grid2 className={OccupationStyles.occupation_card}>


                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Doctarate" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleQualificationChange("Doctarate")}
                      >
                        <span className={OccupationStyles.buttontext}>Doctarate</span>
                      </Button>

                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Graduate" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleQualificationChange("Graduate")}
                      >
                        <span className={OccupationStyles.buttontext}>Graduate</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Illitrate" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleQualificationChange("Illitrate")}
                      >
                        <span className={OccupationStyles.buttontext}>Illitrate</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Others" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleQualificationChange("Others")}
                      >
                        <span className={OccupationStyles.buttontext}>Others</span>
                      </Button>
                    </Grid2>

                  </Grid2>
                  {errType === 24 && <FormHelperText error>{errorMsg}</FormHelperText>}





                  <Typography className={OccupationStyles.title1}>
                    Investment experiences
                  </Typography>

                  <Grid2 sx={{ display: "flex", flexDirection: "row", gap: "7px" }}>
                    <Grid2 className={OccupationStyles.annual_card}>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "0 Year" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleInvestExpChange("0 Year")}
                      >
                        <span className={OccupationStyles.buttontext}>0 Year</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "1 Year" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleInvestExpChange("1 Year")}
                      >
                        <span className={OccupationStyles.buttontext}>1 Year</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "2 Years" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleInvestExpChange("2 Years")}
                      >
                        <span className={OccupationStyles.buttontext}>2 Years</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "3 Years" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleInvestExpChange("3 Years")}
                      >
                        <span className={OccupationStyles.buttontext}>3 Years</span>
                      </Button>

                    </Grid2>


                    <Grid2 className={OccupationStyles.annual_card}>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "4 Years" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleInvestExpChange("4 Years")}
                      >
                        <span className={OccupationStyles.buttontext}>4 Years</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "5 Years" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleInvestExpChange("5 Years")}
                      >
                        <span className={OccupationStyles.buttontext}>5 Years </span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "5 Years - 10 Years" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleInvestExpChange("5 Years - 10 Years")}
                      >
                        <span className={OccupationStyles.buttontext}>5 Years - 10 Years</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "10 Years and more" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleInvestExpChange("10 Years and more")}
                      >
                        <span className={OccupationStyles.buttontext}>10 Years and more</span>
                      </Button>
                    </Grid2>
                  </Grid2>
                  {errType === 25 && <FormHelperText error>{errorMsg}</FormHelperText>}
                </>
                :
                <>

                  <Grid2 className={OccupationStyles.occupation_card}>


                    <Button
                      className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Under Graduate" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleQualificationChange("Under Graduate")}
                    >
                      <span className={OccupationStyles.buttontext}>Under Graduate</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Graduate" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleQualificationChange("Graduate")}
                    >
                      <span className={OccupationStyles.buttontext}>Graduate</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Post Graduate" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleQualificationChange("Post Graduate")}
                    >
                      <span className={OccupationStyles.buttontext}>Post Graduate</span>
                    </Button>
                  </Grid2>

                  <Grid2 className={OccupationStyles.occupation_card}>


                    <Button
                      className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Doctarate" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleQualificationChange("Doctarate")}
                    >
                      <span className={OccupationStyles.buttontext}>Doctarate</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Professional" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleQualificationChange("Professional")}
                    >
                      <span className={OccupationStyles.buttontext}>Professional</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Under High School" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleQualificationChange("Under High School")}
                    >
                      <span className={OccupationStyles.buttontext}>Under High School</span>
                    </Button>
                  </Grid2>

                  <Grid2 className={OccupationStyles.occupation_card}>
                    <Button
                      className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Illitrate" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleQualificationChange("Illitrate")}
                    >
                      <span className={OccupationStyles.buttontext}>Illitrate</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.buttoncard} ${formData2.qualification === "Others" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleQualificationChange("Others")}
                    >
                      <span className={OccupationStyles.buttontext}>Others</span>
                    </Button>
                  </Grid2>
                  {errType === 24 && <FormHelperText error>{errorMsg}</FormHelperText>}





                  <Typography className={OccupationStyles.title1}>
                    Investment experiences
                  </Typography>
                  <Grid2 className={OccupationStyles.annual_card}>
                    <Button
                      className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "0 Year" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleInvestExpChange("0 Year")}
                    >
                      <span className={OccupationStyles.buttontext}>0 Year</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "1 Year" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleInvestExpChange("1 Year")}
                    >
                      <span className={OccupationStyles.buttontext}>1 Year</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "2 Years" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleInvestExpChange("2 Years")}
                    >
                      <span className={OccupationStyles.buttontext}>2 Years</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "3 Years" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleInvestExpChange("3 Years")}
                    >
                      <span className={OccupationStyles.buttontext}>3 Years</span>
                    </Button>

                  </Grid2>


                  <Grid2 className={OccupationStyles.annual_card} sx={{ marginTop: "9px !important" }}>
                    <Button
                      className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "4 Years" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleInvestExpChange("4 Years")}
                    >
                      <span className={OccupationStyles.buttontext}>4 Years</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "5 Years" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleInvestExpChange("5 Years")}
                    >
                      <span className={OccupationStyles.buttontext}>5 Years </span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "5 Years - 10 Years" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleInvestExpChange("5 Years - 10 Years")}
                    >
                      <span className={OccupationStyles.buttontext}>5 Years - 10 Years</span>
                    </Button>
                    <Button
                      className={`${OccupationStyles.annual_buttoncard} ${formData2.investment_exp === "10 Years and more" ? OccupationStyles.selected : ""
                        }`}
                      onClick={() => handleInvestExpChange("10 Years and more")}
                    >
                      <span className={OccupationStyles.buttontext}>10 Years and more</span>
                    </Button>
                  </Grid2>
                  {errType === 25 && <FormHelperText error>{errorMsg}</FormHelperText>}
                </>
            }


            <Grid2 className={OccupationStyles.but_card}>
              <Grid2>

              </Grid2>
              <Grid2>
                <Button className={OccupationStyles.con_button} onClick={handleNextStep}>Continue</Button>
              </Grid2>
            </Grid2>
            <Box className={OccupationStyles.txt_card}>
              <img
                src={icon} // Replace with your image URL
                alt="Checkmark"
                className={OccupationStyles.icon}
              />
              <Typography className={OccupationStyles.txt}>
                Your account details are safe & secure with us.
              </Typography>
            </Box>
          </Box>

        </Box> : occupationAnnual ?
          <Box className={OccupationStyles.main_card}>
            <Box className={OccupationStyles.content_wrapper}>
              {/* <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                width: '100%',
                marginBottom: '10px',
                marginTop: '10px',
              }}>
              
                <Box sx={{
                  position: 'absolute',
                  left: 0,

                  '@media (min-width: 1000px)': {
                    display: 'none' // Explicitly hide above 1000px
                  }
                }}>
                  <IconButton
                    onClick={() => navigate('/step-4')} // Or your custom back handler
                    sx={{
                      color: '#000', // Customize color
                      padding: '16px'
                    }}
                  >
                    <ArrowBack /> 
                  </IconButton>
                </Box>

              
                <img
                  src={Logo}
                  alt="Logo"
                  style={{
                    // Adjust margin to account for arrow on mobile
                    marginLeft: { xs: '40px', md: 0 }
                  }}
                  className={OccupationStyles.nav_logo}
                />
              </Box> */}
              <img
                src={source == "cosmos" ? collab : Logo}
                alt="Logo"
                className={source == "cosmos" ? OccupationStyles.twologo :
                  OccupationStyles.nav_logo}
                alt="Logo"
                style={{
                  // Adjust margin to account for arrow on mobile
                  marginLeft: { xs: '40px', md: 0 }
                }}
              />
              {
                source == "cosmos" &&
                <Typography className={OccupationStyles.txt1}>
                  Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                </Typography>
              }

              <Typography className={OccupationStyles.title}>Occupation</Typography>

              {
                isSmallScreen ?
                  <>
                    <Grid2 sx={{ display: "flex", flexDirection: "row", gap: "7px" }}>
                      <Grid2 className={OccupationStyles.occupation_card}>
                        <Button
                          className={`${OccupationStyles.buttoncard1} ${formData1.occupation === "Private Sector" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleOccupationChange("Private Sector")}
                        >
                          <span className={OccupationStyles.buttontext}>Private Sector</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.buttoncard1} ${formData1.occupation === "Self Employed" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleOccupationChange("Self Employed")}
                        >
                          <span className={OccupationStyles.buttontext}>Self Employed</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.buttoncard1} ${formData1.occupation === "Government Sector" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleOccupationChange("Government Sector")}
                        >
                          <span className={OccupationStyles.buttontext}>Government Sector</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.buttoncard1} ${formData1.occupation === "Public Sector" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleOccupationChange("Public Sector")}
                        >
                          <span className={OccupationStyles.buttontext}>Public Sector</span>
                        </Button>
                      </Grid2>

                      <Grid2 className={OccupationStyles.occupation_card1}>



                        <Button
                          className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Housewife" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleOccupationChange("Housewife")}
                        >
                          <span className={OccupationStyles.buttontext}>Housewife</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Student" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleOccupationChange("Student")}
                        >
                          <span className={OccupationStyles.buttontext}>Student</span>
                        </Button>

                        <Button
                          className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Retired" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleOccupationChange("Retired")}
                        >
                          <span className={OccupationStyles.buttontext}>Retired</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Others" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleOccupationChange("Others")}
                        >
                          <span className={OccupationStyles.buttontext}>Others</span>
                        </Button>
                      </Grid2>


                    


                    </Grid2>
                    {errType === 22 && <FormHelperText error>{errorMsg}</FormHelperText>}







                    <Typography className={OccupationStyles.title1}>
                      Your Annual Income
                    </Typography>
                    <Grid2 sx={{ display: "flex", flexDirection: "row", gap: "7px" }}>

                      <Grid2 className={OccupationStyles.annual_card}>
                        <Button
                          className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "Upto 1 Lakh" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleAnnualChange("Upto 1 Lakh")}
                        >
                          <span className={OccupationStyles.buttontext}>Upto 1 Lakh</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "1-5 lakhs" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleAnnualChange("1-5 lakhs")}
                        >
                          <span className={OccupationStyles.buttontext}>1-5 lakhs</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "5-10 lakhs" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleAnnualChange("5-10 lakhs")}
                        >
                          <span className={OccupationStyles.buttontext}>5-10 lakhs</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "10-25 lakhs" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleAnnualChange("10-25 lakhs")}
                        >
                          <span className={OccupationStyles.buttontext}>10-25 lakhs</span>
                        </Button>

                      </Grid2>


                      <Grid2 className={OccupationStyles.annual_card1} >
                        <Button
                          className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "25- 50 lakhs" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleAnnualChange("25- 50 lakhs")}
                        >
                          <span className={OccupationStyles.buttontext}>25- 50 lakhs</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "50- 1Cr" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleAnnualChange("50- 1Cr")}
                        >
                          <span className={OccupationStyles.buttontext}>50- 1Cr </span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "1Cr- 5Cr" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleAnnualChange("1Cr- 5Cr")}
                        >
                          <span className={OccupationStyles.buttontext}>1Cr- 5Cr</span>
                        </Button>
                        <Button
                          className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "More than 5Cr" ? OccupationStyles.selected : ""
                            }`}
                          onClick={() => handleAnnualChange("More than 5Cr")}
                        >
                          <span className={OccupationStyles.buttontext}>More than 5Cr</span>
                        </Button>
                      </Grid2>
                    
                    </Grid2>
                    {errType === 23 && <FormHelperText error>{errorMsg}</FormHelperText>}
                  </> :
                  <>

                    <Grid2 className={OccupationStyles.occupation_card}>


                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Private Sector" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleOccupationChange("Private Sector")}
                      >
                        <span className={OccupationStyles.buttontext}>Private Sector</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Public Sector" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleOccupationChange("Public Sector")}
                      >
                        <span className={OccupationStyles.buttontext}>Public Sector</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Government Sector" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleOccupationChange("Government Sector")}
                      >
                        <span className={OccupationStyles.buttontext}>Government Sector</span>
                      </Button>
                    </Grid2>

                    <Grid2 className={OccupationStyles.occupation_card} sx={{
                      marginTop: "10px !important",
                      "@media (max-width:1220px)": {
                        marginTop: "5px !important",
                      },
                    }}>


                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Self Employed" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleOccupationChange("Self Employed")}
                      >
                        <span className={OccupationStyles.buttontext}>Self Employed</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Housewife" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleOccupationChange("Housewife")}
                      >
                        <span className={OccupationStyles.buttontext}>Housewife</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Student" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleOccupationChange("Student")}
                      >
                        <span className={OccupationStyles.buttontext}>Student</span>
                      </Button>
                    </Grid2>

                    <Grid2 className={OccupationStyles.occupation_card} sx={{
                      marginTop: "10px !important",
                      "@media (max-width:1220px)": {
                        marginTop: "5px !important",
                      },

                    }}>
                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Retired" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleOccupationChange("Retired")}
                      >
                        <span className={OccupationStyles.buttontext}>Retired</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.buttoncard} ${formData1.occupation === "Others" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleOccupationChange("Others")}
                      >
                        <span className={OccupationStyles.buttontext}>Others</span>
                      </Button>
                    </Grid2>
                    {errType === 22 && <FormHelperText error>{errorMsg}</FormHelperText>}

                    <Typography className={OccupationStyles.title1}>
                      Your Annual Income
                    </Typography>
                    <Grid2 className={OccupationStyles.annual_card}>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "Upto 1 Lakh" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleAnnualChange("Upto 1 Lakh")}
                      >
                        <span className={OccupationStyles.buttontext}>Upto 1 Lakh</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "1-5 lakhs" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleAnnualChange("1-5 lakhs")}
                      >
                        <span className={OccupationStyles.buttontext}>1-5 lakhs</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "5-10 lakhs" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleAnnualChange("5-10 lakhs")}
                      >
                        <span className={OccupationStyles.buttontext}>5-10 lakhs</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "10-25 lakhs" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleAnnualChange("10-25 lakhs")}
                      >
                        <span className={OccupationStyles.buttontext}>10-25 lakhs</span>
                      </Button>

                    </Grid2>


                    <Grid2 className={OccupationStyles.annual_card} sx={{ marginTop: "9px !important" }}>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "25- 50 lakhs" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleAnnualChange("25- 50 lakhs")}
                      >
                        <span className={OccupationStyles.buttontext}>25- 50 lakhs</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "50- 1Cr" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleAnnualChange("50- 1Cr")}
                      >
                        <span className={OccupationStyles.buttontext}>50- 1Cr </span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "1Cr- 5Cr" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleAnnualChange("1Cr- 5Cr")}
                      >
                        <span className={OccupationStyles.buttontext}>1Cr- 5Cr</span>
                      </Button>
                      <Button
                        className={`${OccupationStyles.annual_buttoncard} ${formData1.annual_income === "More than 5Cr" ? OccupationStyles.selected : ""
                          }`}
                        onClick={() => handleAnnualChange("More than 5Cr")}
                      >
                        <span className={OccupationStyles.buttontext}>More than 5Cr</span>
                      </Button>
                    </Grid2>
                    {errType === 23 && <FormHelperText error>{errorMsg}</FormHelperText>}
                  </>
              }



              <Grid2 className={OccupationStyles.but_card}>
                <Grid2>

                </Grid2>
                <Grid2>
                  <Button className={OccupationStyles.con_button} onClick={handleGotoInvest}>Continue</Button>
                </Grid2>
              </Grid2>
              <Box className={OccupationStyles.txt_card}>
                <img
                  src={icon} // Replace with your image URL
                  alt="Checkmark"
                  className={OccupationStyles.icon}
                />
                <Typography className={OccupationStyles.txt}>
                  Your account details are safe & secure with us.
                </Typography>
              </Box>
            </Box>

          </Box> :
          <Box className={PersonalStyles.main_card}>
            <Box className={PersonalStyles.content_wrapper}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection:"column",
                justifyContent: 'center',
                position: 'relative',
                width: '100%',
                marginBottom: '10px',
                marginTop: '10px',
              }}>
                {/* Back arrow button - only shows below 1000px */}
                <Box sx={{
                  position: 'absolute',
                  left: 0,

                  '@media (min-width: 1000px)': {
                    display: 'none' // Explicitly hide above 1000px
                  },
                  '@media (max-width: 510px)': {
                    marginBottom: "20px"
                  }
                }}>
                  <IconButton
                    onClick={() => navigate('/step-4')} // Or your custom back handler
                    aria-label="Go back"
                    sx={{
                      color: '#000', // Customize color
                      padding: '16px',
                      '@media (max-width: 400px)': {
                        paddingLeft: "5px"
                      }
                    }}
                  >
                    <ArrowBack /> {/* Make sure to import from @mui/icons-material */}
                  </IconButton>
                </Box>

                {/* Logo - centered */}
                
                <img
                  src={source == "cosmos" ? collab : Logo}
                  alt="Logo"
                  className={source == "cosmos" ? OccupationStyles.twologo :
                    OccupationStyles.nav_logo}
                  alt="Logo"
                  style={{
                    // Adjust margin to account for arrow on mobile
                    marginLeft: { xs: '40px', md: 0 }
                  }}
                />
                {
                  source == "cosmos" &&
                  <Typography className={OccupationStyles.txt1}>
                    Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                  </Typography>
                }
              </Box>
              <Typography className={PersonalStyles.heading}>
                Enter your Personal Details
              </Typography>
              <Grid2 className={PersonalStyles.inner_card}>
                {/* Gender Section */}
                <Grid2 sx={{ marginBottom: "20px !important" }}>
                  <Typography className={PersonalStyles.gender}>Gender</Typography>
                  <div style={{ display: "flex", gap: "13px", marginTop: "5px" }}>
                    <Button
                      className={`${PersonalStyles.buttoncard} ${formData.gender === "MALE" ? PersonalStyles.selected : ""
                        }`}
                      onClick={() => handleGenderChange("MALE")}
                    >
                      <img
                        src={male}
                        alt="Men Icon"
                        className={PersonalStyles.male_icon}

                      />
                      <span className={PersonalStyles.buttontext}>Men</span>
                    </Button>
                    <Button
                      className={`${PersonalStyles.buttoncard} ${formData.gender === "FEMALE" ? PersonalStyles.selected : ""
                        }`}
                      onClick={() => handleGenderChange("FEMALE")}
                    >
                      <img
                        src={female}
                        alt="Female Icon"
                        className={PersonalStyles.gender_icon}

                      />
                      <span className={PersonalStyles.buttontext}>Women</span>
                    </Button>
                  </div>
                  {errType === 4 && (
                    <FormHelperText error>{errorMsg}</FormHelperText>
                  )}
                </Grid2>

                {/* Marital Status Section */}
                <Grid2 sx={{ marginBottom: "20px !important" }}>
                  <Typography className={PersonalStyles.marital}>
                    Marital Status
                  </Typography>
                  <div style={{ display: "flex", gap: "13px", marginTop: "5px" }}>
                    <Button
                      className={`${PersonalStyles.buttoncard} ${formData.marital_status === "Married" ? PersonalStyles.selected : ""
                        }`}
                      onClick={() => handleMaritalChange("Married")}
                    >
                      <span className={PersonalStyles.buttontext}>Married</span>
                    </Button>
                    <Button
                      className={`${PersonalStyles.buttoncard} ${formData.marital_status === "Unmarried" ? PersonalStyles.selected : ""
                        }`}
                      onClick={() => handleMaritalChange("Unmarried")}
                    >
                      <span className={PersonalStyles.buttontext}>Unmarried</span>
                    </Button>
                  </div>
                  {errType === 5 && (
                    <FormHelperText error sx={{textAlign:"center"}}>{errorMsg}</FormHelperText>
                  )}
                </Grid2>
              </Grid2>


              <Typography className={PersonalStyles.marital}>
                Father's/Spouse's Name*
              </Typography>
              <TextField
                variant="outlined"
                placeholder="Father's/Spouse's Name*"
                value={formData.guardian}
                onChange={handleGuardianChange}
                // onBlur={validateFatherName}
                // inputRef={fatherNameRef}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "39px",
                  marginTop: "22px",
                  "@media (max-height: 710px)": {
                    marginTop: "15px",
                  },
                  "& input": {
                    display: "flex",
                    alignItems: "center",
                    padding: "13px 12px",
                    textAlign: "center !important",
                    fontFamily: "Inter400 !important",
                    fontSize: "24px !important",
                    lineHeight: "29px !important",
                    "&::placeholder": {
                      fontSize: "18px",
                      fontFamily: "Inter400",
                      textAlign: "center",
                      letterSpacing: "0px",
                      lineHeight: "22px",
                    },
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "39px",
                      height: "65px !important",
                      width: "379px !important",
                      borderColor: "#000000", // Default border
                      transition: "border-color 0.3s ease", // Smooth transition for focus
                    },
                    "&:hover fieldset": {
                      borderColor: "#000000", // Border remains consistent on hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#000000", // Border remains consistent on focus
                      borderWidth: "1px",
                    },
                  },
                  width: "399px",
                  height: "60px !important",
                  "@media (max-width: 1150px)": {
                    width: "316px",
                    height: "46px !important",
                    "& input": {
                      fontSize: "18px !important",
                    },
                    "& .MuiOutlinedInput-root fieldset": {
                      height: "50px !important",
                      width: "299px !important",
                    },
                  },
                  "@media (max-width: 515px)": {
                    width: "286px",
                    height: "46px !important",
                    "& input": {
                      fontSize: "17px !important",
                    },
                    "& .MuiOutlinedInput-root fieldset": {
                      height: "50px !important",
                      width: "270px !important",
                    },
                  },
                }}
              />
              {errType === 21 && <FormHelperText error>{errorMsg}</FormHelperText>}

              <Grid2
                container
                spacing={2}
                direction={{ md: "row !important" }}
                className={PersonalStyles.but_card}
              >
                <Grid2>
                  {!userData?.steps?.["Personal Detail"]?.status && <Button
                    className={PersonalStyles.skip_button}
                    variant="outlined"
                    fullWidth
                    onClick={handleSkipPD}
                  >
                    Skip Now
                  </Button>}
                </Grid2>
                <Grid2>
                  <Button
                    className={PersonalStyles.con_button}
                    onClick={handleGotoOccupation}
                    fullWidth
                  >
                    Continue
                  </Button>
                </Grid2>
              </Grid2>

              <Box className={PersonalStyles.card}>
                <img
                  src={icon} // Replace with your image URL
                  alt="Checkmark"
                  className={PersonalStyles.icon}
                />
                <Typography className={PersonalStyles.txt}>
                  Your account details are safe & secure with us.
                </Typography>
              </Box>
            </Box>
          </Box>
      }
    </Box>
    </main>
  );
}
